// Настройки, по которым уходит запрос: текущий промпт-бар либо снимок
// повторяемой генерации.

import type { ChatSettingsValues } from "~/shared/store/useChatSettingsStore";
import type { PromptPrefill } from "~/shared/store/types";

/**
 * Готовый заказ: «повторить ровно это». Настройки и раскладка входов берутся из
 * снимка повторяемой генерации, а не из промпт-бара — тем же сборщиком, что
 * заполняет бар при «Повторить запрос» (`buildRepeatPrefill`), поэтому второго
 * правила разбора снимка не заводится.
 */
export type RepeatOrder = Pick<PromptPrefill, "settings" | "attachments" | "elementIds">;

/**
 * Настройки отправки: без заказа — текущий бар, с заказом — снимок поверх него.
 *
 * Повтор идёт по снимку, а не по бару: человек мог с тех пор сменить модель,
 * разрешение или размер пакета, и «Повторить» уходило другим — порой более
 * дешёвым — заказом, выдавая его за тот же (повтор пакета 2K ×4 после
 * перезагрузки страницы уезжал как 1024p ×1).
 *
 * Осей, которых в снимке нет, у той генерации не было вовсе. Соотношение и
 * разрешение тогда берутся из бара — отправлять больше нечего, а режим сам
 * решит, нужны ли они. Размер пакета — единицей: это деньги, и «пакета не было»
 * тут честнее любого числа из бара.
 */
export function resolveOrderSettings(
    current: ChatSettingsValues,
    repeat: RepeatOrder | undefined,
): ChatSettingsValues {
    if (!repeat) return current;
    return {
        ...current,
        ...repeat.settings,
        characterOrientation: repeat.settings.characterOrientation ?? null,
        upscaleFactor: repeat.settings.upscaleFactor ?? null,
        batchSize: repeat.settings.batchSize ?? 1,
    };
}
